export const FormGroupDirection = {
	HORIZONTAL: 'horizontal',
	VERTICAL: 'vertical',
};

export type FormGroupDirection =
	(typeof FormGroupDirection)[keyof typeof FormGroupDirection];
